import './global/icons';
import './global/_styles.scss';

import { Amplify } from 'aws-amplify';
import React, { Component } from 'react';
import { Container } from 'react-bootstrap';

import AlertBar from './components/AlertBar';
import Footer from './components/Footer';
import Header from './components/Header';
import Router from './router/routes';
import backend, { ENVIRONMENT } from './services/backend';

class App extends Component {
  state = {
    environment: null,
  };

  async componentDidMount() {
    const env = await backend.get(ENVIRONMENT);

    this.setState(({ environment: `${env.data.envName}` }));

    Amplify.configure({
      Auth: {
        userPoolId: env.data.userPoolId,
        userPoolWebClientId: env.data.clientId,
      },
    });
  }

  render() {
    const { environment } = this.state;

    return (
      <div className="App">
        <Header environment={environment} />
        <Container className="App__container">
          <AlertBar />
          <Router environment={environment} />
        </Container>
        <Footer />
      </div>
    );
  }
}

export default App;
